import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getCompiledPath } from '../../util';
import styles from './surveySchemaPartList.module.css';
import { routes } from '../../constants';

const SurveySchemaPartListRow = ({
  surveyPartId, title, description, code, onSelectSchemaPart, selectable, sideBorders, version,
  status, disabled, translate: t
}) => {
  const rowClasses =
      `${sideBorders && styles.sideBorders}
       ${styles.row}`;
  const titleLink = (selectable)
    ? title
    : <Link to={getCompiledPath(routes.surveySchemas.surveyParts.surveyPart.index, { surveyPartId })}>{title}</Link>;

  const onClick = (event) => {
    if (selectable) {
      onSelectSchemaPart(event);
    }
  };

  return (
    <tr className={rowClasses} data-cy="survey-schema-part-list-row">
      {selectable
        && (
        <td>
          <button
            type="button"
            className={`button icon--plus ${disabled ? 'disabled' : ''}`}
            aria-label={`${t('common.add')} ${title} ${code}`}
            onClick={onClick}
            disabled={disabled}
            data-cy="add-schema-part-plus-button"
          />
        </td>
        )}
      <td data-cy="survey-schema-part-list-code">{code}</td>
      <td data-cy="survey-schema-part-list-title-link">{titleLink}</td>
      <td data-cy="survey-schema-part-list-description">{description}</td>
      <td className={styles.centeredText} data-cy="survey-schema-part-list-version">{version}</td>
      <td data-cy="survey-schema-part-list-status">{status}</td>
      { selectable && <td />}
    </tr>
  );
};

const {
  string, func, bool, number, node
} = PropTypes;

SurveySchemaPartListRow.propTypes = {
  surveyPartId: number.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  code: string.isRequired,
  version: number.isRequired,
  selectable: bool.isRequired,
  onSelectSchemaPart: func.isRequired,
  sideBorders: bool,
  status: node.isRequired,
  disabled: bool,
  translate: func.isRequired
};

SurveySchemaPartListRow.defaultProps = {
  sideBorders: false,
  disabled: false
};

export default SurveySchemaPartListRow;
